import { render, staticRenderFns } from "./ClosingsChips.vue?vue&type=template&id=5c4dd5a8"
import script from "./ClosingsChips.vue?vue&type=script&lang=js"
export * from "./ClosingsChips.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/latinad/panel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c4dd5a8')) {
      api.createRecord('5c4dd5a8', component.options)
    } else {
      api.reload('5c4dd5a8', component.options)
    }
    module.hot.accept("./ClosingsChips.vue?vue&type=template&id=5c4dd5a8", function () {
      api.rerender('5c4dd5a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/table-cells/ClosingsChips.vue"
export default component.exports